import LocationBanner from "./location-banner";


export default LocationBanner;